var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 98",
    width: 98,
    height: 98,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-149-1369h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff8a33}.b{fill:#e7ecf1}.c{fill:#ed5875}.d{fill:#657272}.e{fill:#c6d0da}.f{fill:#55aaa0}.g{fill:#4a998e}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m97.7 48.6c0 12.3-4.6 23.5-12.1 32.1-4.7 5.3-10.6 9.6-17.2 12.4q-1.8 0.8-3.7 1.4-2.4 0.8-4.8 1.3-5.1 1.2-10.6 1.2-5.4 0-10.5-1.2c-0.7-0.1-1.3-3.1-1.9-3.3-1-0.2-2 2.3-2.9 2q-1.9-0.6-3.7-1.4c-2.5-1.1-1-6.4-3.3-7.9-3.7-2.4-11-1.2-13.9-4.5-7.5-8.6-12.1-19.8-12.1-32.1 0-12.2 4.6-23.5 12.1-32 4.7-5.3 10.6-9.6 17.2-12.4q1.8-0.8 3.7-1.4 2.3-0.8 4.8-1.4 5.1-1.1 10.5-1.1 5.5 0 10.6 1.1 2.4 0.6 4.8 1.4 1.9 0.6 3.7 1.4c6.6 2.8 12.5 7.1 17.2 12.4 7.5 8.5 12.1 19.8 12.1 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m85.6 0.3v96.7l-6.1-4.6-6 4.6-5.1-3.9-0.9-0.7-2.8 2.1-3.3 2.5-1.5-1.2-4.5-3.4-6.1 4.6-6-4.6-4.5 3.4q-2.5-0.5-4.8-1.3l-2.8-2.1-0.9 0.7c-6.6-2.8-12.5-7.1-17.2-12.4v-80.4l6 4.6 6.1-4.6 5.1 3.9 0.9 0.7 2.8-2.1 3.3-2.5 1.5 1.1 4.5 3.5 6-4.6 6.1 4.6 4.5-3.5 1.5-1.1 3.3 2.5 2.8 2.1 0.9-0.7 5.1-3.9 6 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m59.1 29.8q0 0 0 0c-1.2 0-2.6 0-3.6 0v-13.9c0-1-0.9-1.9-1.9-1.9-1 0-1.9 0.9-1.9 1.9v15.8c0 0.9 0.7 1.7 1.6 1.9 0.1 0 0.2 0 2 0 0.8 0 2 0 3.8 0 1.1 0 1.9-0.9 1.9-1.9 0-1-0.8-1.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m70.2 29.8q0 0 0 0c-1.2 0-2.6 0-3.6 0v-13.9c0-1-0.8-1.9-1.9-1.9-1 0-1.9 0.9-1.9 1.9v15.8c0 0.9 0.7 1.7 1.6 1.9 0.1 0 0.2 0 2 0 0.8 0 2 0 3.9 0 1 0 1.8-0.9 1.8-1.9 0-1-0.8-1.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m45.5 14.6c-1.1 0-1.9 0.9-1.9 1.9v15.8c0 1.1 0.8 1.9 1.9 1.9 1 0 1.9-0.8 1.9-1.9v-15.8c0-1-0.9-1.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m40 28.1c0 3.3-2.8 6.1-6.2 6.1-1.1 0-5.4 0-5.4 0-0.5 0-0.9-0.2-1.3-0.5-0.3-0.4-0.5-0.9-0.5-1.4v-15.8c0-1 0.8-1.9 1.8-1.9h4.6c3.1 0 5.6 2.5 5.6 5.6 0 1.1-0.4 2.1-1 3 1.5 1.2 2.4 2.9 2.4 4.9zm-9.7-9.7v3.5h1c0.7 0 1.4 0 1.7 0 1 0 1.8-0.8 1.8-1.7 0-1-0.8-1.8-1.8-1.8 0 0-2.7 0-2.7 0zm5.9 9.7c0-1.3-1.1-2.4-2.4-2.4h-2.4q-0.6 0-1.1 0v4.7c1.3 0 2.9 0 3.5 0 1.3 0 2.4-1 2.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m52.9 52h-27.4c-1.1 0-2-0.9-2-1.9 0-1.1 0.9-2 2-2h27.4c1.1 0 1.9 0.9 1.9 2 0 1-0.8 1.9-1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m73.2 52h-5c-1.1 0-2-0.9-2-1.9 0-1.1 0.9-2 2-2h5c1.1 0 1.9 0.9 1.9 2 0 1-0.8 1.9-1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m56.1 62.4h-30.6c-1.1 0-2-0.8-2-1.9 0-1.1 0.9-2 2-2h30.6c1.1 0 2 0.9 2 2 0 1.1-0.9 1.9-2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m73.2 62.4h-5c-1.1 0-2-0.8-2-1.9 0-1.1 0.9-2 2-2h5c1.1 0 1.9 0.9 1.9 2 0 1.1-0.8 1.9-1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m48.2 72.9h-22.7c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h22.7c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m73.2 72.9h-5c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h5c1.1 0 1.9 0.9 1.9 2 0 1.1-0.8 2-1.9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m56.1 83.3h-30.6c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h30.6c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m73.2 83.3h-5c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2h5c1.1 0 1.9 0.9 1.9 2 0 1.1-0.8 2-1.9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m80.6 59.1c-1.6 0-3.2-0.8-4.2-2.1l-8.9-11.5c-1.8-2.3-1.4-5.7 1-7.5 2.3-1.8 5.6-1.3 7.4 1l4 5.1 7.8-13.8c1.5-2.5 4.7-3.4 7.3-2 2.6 1.5 3.5 4.7 2 7.3l-11.7 20.8c-0.9 1.5-2.5 2.5-4.3 2.7q-0.2 0-0.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m82.2 47l9.4-16.7c0.6-1.1 1.6-1.9 2.7-2.3-2.4-1-5.2 0-6.6 2.3l-7.8 13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m80.3 57l-8.9-11.5c-1.8-2.3-1.4-5.7 0.9-7.5q0.6-0.4 1.3-0.7c-1.6-0.7-3.6-0.4-5.1 0.7-2.4 1.8-2.8 5.2-1 7.5l8.9 11.5c1 1.3 2.6 2.1 4.2 2.1q0.2 0 0.4 0 0.8-0.1 1.6-0.4c-0.9-0.3-1.7-0.9-2.3-1.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.795c250edc26fbaf8768d59649cb1b92.svg";
export { ForwardRef as ReactComponent };